// src/utils/permissoesOverrides.js
// Helpers para:
// - mesclar PERMISSOES_DEFAULT com overrides do Firestore (por grupo)
// - achatar em linhas (para UI estilo planilha)

function isObj(v) {
  return v && typeof v === "object" && !Array.isArray(v);
}

export function mergePermissoes(defaults, overrides) {
  if (!isObj(defaults)) return defaults;
  const out = Array.isArray(defaults) ? [...defaults] : { ...defaults };

  if (!isObj(overrides)) return out;

  for (const [k, v] of Object.entries(overrides)) {
    const base = defaults?.[k];

    // Ignora chaves desconhecidas (evita módulos removidos aparecerem via overrides)
    if (!Object.prototype.hasOwnProperty.call(defaults, k)) continue;

    // Leaf: { nivelMinimo, escopo? }
    if (isObj(v) && ("nivelMinimo" in v || "escopo" in v)) {
      const mergedLeaf = isObj(base) ? { ...base } : {};
      if ("nivelMinimo" in v) mergedLeaf.nivelMinimo = v.nivelMinimo;
      if ("escopo" in v) mergedLeaf.escopo = v.escopo ?? undefined;
      out[k] = mergedLeaf;
      continue;
    }

    // Node
    if (isObj(v) && isObj(base)) {
      out[k] = mergePermissoes(base, v);
      continue;
    }

    // Fallback: substitui
    out[k] = v;
  }

  return out;
}

export function flattenPermissoes(permissoes) {
  const rows = [];

  function walk(node, path) {
    if (!isObj(node)) return;

    // Leaf
    if ("nivelMinimo" in node) {
      const [modulo, recurso, acao] = path;
      rows.push({
        id: path.join("."),
        modulo,
        recurso,
        acao,
        nivelMinimo: node.nivelMinimo ?? 0,
        escopo: isObj(node.escopo) ? node.escopo : undefined,
      });
      return;
    }

    for (const [k, v] of Object.entries(node)) {
      walk(v, [...path, k]);
    }
  }

  for (const [modulo, modNode] of Object.entries(permissoes || {})) {
    for (const [recurso, recNode] of Object.entries(modNode || {})) {
      for (const [acao, leaf] of Object.entries(recNode || {})) {
        walk(leaf, [modulo, recurso, acao]);
      }
    }
  }

  rows.sort((a, b) =>
    (a.modulo || "").localeCompare(b.modulo || "") ||
    (a.recurso || "").localeCompare(b.recurso || "") ||
    (a.acao || "").localeCompare(b.acao || "")
  );

  return rows;
}

export function setDeepLeaf(obj, pathArr, value) {
  let cur = obj;
  for (let i = 0; i < pathArr.length - 1; i++) {
    const k = pathArr[i];
    if (!isObj(cur[k])) cur[k] = {};
    cur = cur[k];
  }
  cur[pathArr[pathArr.length - 1]] = value;
}
